import timeIntervalPicker from './timeintervalpicker.vue'

// 时间区间选择器
const timeInterval = {
    install(Vue) {
        Vue.component('zh-timeinterval', timeIntervalPicker)
    }
}

export default timeInterval;
